<template>
  <div>
    <div class="container">
      <CreateTitle :title="page_title"/>

      <div class="create">
        <loader :isLoading="is_request_in_progress"/>

        <div class="row">
          <div class="col-sm">
            <CreatePageImage :src="image.url" :alt="image.alt" :width="image.width" />
          </div>

          <div class="col-sm form-container">
            <form @submit.prevent="next" id="form-create" novalidate>

              <InputComponent
                type="text"
                for="input-country"
                label_text="Country"
                attribute="Country"
                placeholder="Philippines"
                v-model="form.country"
                :v="$v.form.country"
               />

               <InputComponent
                type="text"
                for="input-province"
                label_text="State/Region/Province"
                attribute="State/Region/Province"
                placeholder="NCR"
                v-model="form.province"
                :v="$v.form.province"
               />

               <InputComponent
                type="text"
                for="input-city"
                label_text="City"
                attribute="City"
                placeholder="Quezon City"
                v-model="form.city"
                :v="$v.form.city"
               />

              <InputComponent
                type="text"
                for="building-name"
                label_text="Building Name"
                attribute="Building Name"
                placeholder="Building XYZ"
                v-model="form.building_name"
                :v="$v.form.building_name"
               />

               <InputComponent
                type="text"
                for="building-address"
                label_text="Building Address"
                attribute="Building Address"
                placeholder="123 Awesome Street Taguig City"
                v-model="form.building_address"
                :v="$v.form.building_address"
               />

               <InputComponent
                type="text"
                for="company-floor"
                label_text="Company unit and floor number"
                attribute="Company unit and floor number"
                placeholder="Unit 202, 23rd floor"
                v-model="form.company_floor"
                :v="$v.form.company_floor"
               />

              <div class="text-center">
                <button type="submit" class="btn btn-primary">Next</button>
              </div>

            </form>
          </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import CreateTitle from '@/components/common/CreateTitle'
import CreatePageImage from '@/components/common/CreatePageImage'
import Loader from '@/components/common/Loader'

import InputComponent from '@/components/form/InputComponent'

import { ASSET_CREATE_PROFILE_2 } from '@/api/constants/ImageAssets'
import { APIService } from '@/api/APIService'

const api = new APIService()

export default {
  components: {
    CreateTitle,
    CreatePageImage,
    InputComponent,
    Loader
  },
  props: {
    companyId: String,
    isOrganizer: String
  },
  data() {
    return {
      page_title: 'Create Building Profile',
      image: ASSET_CREATE_PROFILE_2,
      form: {
        country: '',
        province: '',
        city: '',
        building_name: '',
        building_address: '',
        company_floor: ''
      },
      error: {
        country: '',
        province: '',
        city: '',
        building_name: '',
        building_address: '',
        company_floor: '',
        message: ''
      },
      haveErrors: false,
      is_request_in_progress: false
    }
  },
  validations: {
    form: {
      country: { required },
      province: { required },
      city: { required },
      building_name: { required },
      building_address: { required },
      company_floor: { required }
    }
  },
  mounted() {
    if(this.isOrganizer !== 'false') this.redirectToPage()
  },
  methods: {
    next() {
      // Temporary validation set up since we are going to change to Google Maps API
      this.$v.$touch()

      if (!this.$v.form.$invalid){
        return this.updateProfileFields()
      }

    },
    async updateProfileFields() {
      try {
        const fields = { company_details: { ...this.form } }
        this.is_request_in_progress = true
        const responseData = await api.updateCompanyProfile(this.companyId, fields)
        if(responseData){
          if(responseData.statusCode === 200) this.redirectToPage()
          else this.error.message = 'something here'
        } else {
          this.error.message = 'session expired'
        }
        this.is_request_in_progress = false
      } catch(err) {
        this.is_request_in_progress = false
        if(err.message) this.error.message = this.message
        else this.error.message = err
      }
    },
    redirectToPage() {
      this.$router.push(`/create-profile/business/${this.companyId}/instructions`)
    }
  }
}

</script>

<style>
  @import '../../assets/styles/form-style-1.css'
</style>



// WEBPACK FOOTER //
// src/containers/business_profile/CreateBusinessProfileAddress.vue